import * as React from 'react';

import { cn } from '../../lib/utils';
import { controlBase, controlStates } from '../../lib/control';

/**
 * Text input — the handoff's section 04.
 *
 * The box and its four states come from `lib/control`, shared with Textarea and
 * with whatever control is added next; what is left here is the part that is
 * only true of a single-line input — its height, and the file and selection
 * styling a textarea has no use for.
 *
 * Validate on blur, never on keystroke. Nothing in this file decides that;
 * `aria-invalid` is the only switch, and setting it is the form's job (see
 * Field, which sets it for you).
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        controlBase,
        controlStates,
        'h-9 min-w-0 py-1',
        'selection:bg-primary selection:text-primary-foreground',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
